"use strict";
// @ts-ignore
try {
    self['workbox:window:7.4.0'] && _();
}
catch (e) { }
